<template>
    <div class="emotion">
        <div class="emotion_top">
            <img src="@/assets/images/grow-club/back.png" class="emotion_top_goback" @click="goback" />
            <img src="@/assets/images/grow-club/emotion-people.png" class="emotion_top_right" />
        </div>
        <div class="emotion_bot">
            <div class="emotion_bot_left" @click="goGameone">
                <img src="@/assets/images/grow-club/game-pic1.png"  class="emotion_bot_left_pic" />
                <div class="emotion_bot_left_title">
                    <p class="emotion_bot_left_title_top">连连看-识别情绪</p>
                    <p class="emotion_bot_left_title_bot">Pop</p>
                </div>
            </div>
            <div class="emotion_bot_right" @click="goGameTwo">
                <img src="@/assets/images/grow-club/game-pic2.png"  class="emotion_bot_right_pic" />
                <div class="emotion_bot_right_title">
                    <p class="emotion_bot_right_title_top">表情包大拼接</p>
                    <p class="emotion_bot_right_title_bot">Jigsaw</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { _getChildDetail } from '../../api/game';
import {horizontalScreen} from '../../assets/js/horizontal';
import { decryptBy , encryptBy } from '@/assets/js/encryption';
export default {
    name: 'emotion',
    data () {
        return {
            headImg:'',//头像
            male:require('../../assets/images/family-archives/boy.png'),//男孩默认图片
			female:require('../../assets/images/family-archives/girl.png'),//女孩默认图片
            nickName:'' //昵称
        }
    },
    created() {
        let childId = localStorage.getItem("childId");
        this.getChildDetail(childId);
        let children = JSON.parse(decryptBy(localStorage.getItem("children")));
        let child = children.filter((item) => {
           return item.id == childId
        })
        if(child[0]&&child[0].headImg) {
            // this.headImg = 'http://172.16.12.229:9100/' + child[0].headImg;
		    // this.headImg = 'http://' + location.host + '/' + child[0].headImg;
            this.headImg = child[0].headImg;
        }else {
            if(child[0]&&child[0].sex ===1) {
                this.headImg = this.male;
            } else {
                this.headImg = this.female;
            }
        }
        localStorage.setItem("headImg", this.headImg);
        if(child[0]&&child[0].sex) {
            localStorage.setItem("sex", child[0].sex);
        }
    },
    mounted() {
        horizontalScreen();
    },
    methods: {
        //返回
        goback() {
            this.$router.push('growGroup');
        },
        //跳转到连连看
        goGameone() {
            localStorage.setItem("pageFlag",1);
            this.$router.push({
                path:'/gameIndex',
                query:{
                    nextFlag: false
                }
            })
        },
        //跳转到拼图
        goGameTwo() {
            this.$router.push('jigsawIndex');
        },
        //获取儿童信息
        getChildDetail(childId) {
            _getChildDetail(childId).then(res=>{
                if(res.code == 200){
                    this.nickName = res.data.nickName ? res.data.nickName : '';
                    localStorage.setItem("studentName", this.nickName);
                }
            })
        }
    }
}
</script>
<style lang='scss' scoped>
    .emotion {
        width: 100%;
        height: 100%;
        background: url(./../../assets/images/grow-club/emotion-bg.png);
        background-size: cover;
        .emotion_top {
            display: flex;
            justify-content: space-between;
            .emotion_top_goback {
                width: 29px;
                height: 29px;
                margin: 15px 0 0 15px;
            }
            .emotion_top_right {
                width: 123px;
                height: 53px;
                margin: 10px 20px 0 0;
            }
        }
        .emotion_bot {
            margin-top: 70px;
            display: flex;
            justify-content: space-around;
            padding: 0 10px;
            .emotion_bot_left {
                width: 282px;
                height: 130px;
                background: url('./../../assets/images/grow-club/game1.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                margin-right: 30px;
                display: flex;
                align-items: center;
                .emotion_bot_left_pic {
                    width: 105px;
                    height: 105px;
                }
                .emotion_bot_left_title {
                    width: 150px;
                    text-align: center;
                    .emotion_bot_left_title_top {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #D55514;
                        line-height: 25px;
                    }
                    .emotion_bot_left_title_bot {
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 22px;
                    }
                }
            }
            .emotion_bot_right {
                width: 282px;
                height: 130px;
                background: url('./../../assets/images/grow-club/game2.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                display: flex;
                justify-content: space-around;
                align-items: center;
                .emotion_bot_right_pic {
                    width: 105px;
                    height: 105px;
                }
                .emotion_bot_right_title {
                    width: 150px;
                    text-align: center;
                    .emotion_bot_right_title_top {
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #D55514;
                        line-height: 25px;
                    }
                    .emotion_bot_right_title_bot {
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 22px;
                    }
                }
            }
        }
    }
    @media screen and (device-width: 412px) and (-webkit-min-device-pixel-ratio: 3) {
        .emotion_bot_left {
            border: 1px solid red !important;
        }
    }
</style>
